
import React from 'react'
import { ProfileData } from '../../../../helpers/models/Models';
import SecHeading from '../../../../constants/SecHeading';
import { CiLocationOn } from "react-icons/ci";
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import { IoWaterOutline } from "react-icons/io5";

interface ProfileDataDetailsProps {
    ProfileDataDetails: ProfileData | null;
}
const TapDetailsView: React.FC<ProfileDataDetailsProps> = ({ ProfileDataDetails }) => {
    return (
        <div>
            <SecHeading icon={<IoWaterOutline />} type='add' label='Tap Details' />
            <p className="border-t border-slate-300 pt-2 border-dashed"></p>
            <Grid container columnSpacing={3} rowSpacing={1}>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Old System No.:' name='spouses_name' type='text' value={ProfileDataDetails?.old_sys_no || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Meter Connection Date:' name='spouses_name' type='text' value={ProfileDataDetails?.meter_conn_date || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Meter Reading Zone:' name='spouses_name' type='text' value={ProfileDataDetails?.meter_reading_zone || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Serial No.:' name='spouses_name' type='text' value={ProfileDataDetails?.serial_no || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Serial Suffix.:' name='spouses_name' type='text' value={ProfileDataDetails?.serial_suffix || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Area No.:' name='spouses_name' type='text' value={ProfileDataDetails?.area_no || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Meter Status:' name='spouses_name' type='text' value={ProfileDataDetails?.meter_status===1?"Connection is Active":"Connection is Process" || ""} disabled />
                </Grid> 
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Customer Type:' name='spouses_name' type='text' value={ProfileDataDetails?.customer_type===1?"Apang":"Normal" || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Meter Type:' name='spouses_name' type='text' value={ProfileDataDetails?.meter_type===1?"Personal":"Organization" || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Tap Type:' name='spouses_name' type='text' value={ProfileDataDetails?.tap_type===1?"Permanent":"Temporary" || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Tap No.:' name='spouses_name' type='text' value={ProfileDataDetails?.tap_no || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Discount Unit:' name='spouses_name' type='text' value={ProfileDataDetails?.discount_unit || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Reading Day:' name='spouses_name' type='text' value={ProfileDataDetails?.reading_day || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Meter SN:' name='spouses_name' type='text' value={ProfileDataDetails?.meter_sn || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Reading Effective:' name='spouses_name' type='text' value={ProfileDataDetails?.reading_effective || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Tap Status:' name='spouses_name' type='text' value={ProfileDataDetails?.tap_status || ""} disabled />
                </Grid>
            </Grid>
        </div>
    )
}

export default TapDetailsView